@if (imageToDisplay) {
  <img #image
    [class.object-fit-cover]="objectFitCover()"
    [class.bcimage]="bcimage()"
    [class.overlap]="overlap()"
    [class.desktop-overlap]="desktopOverlap()"
    [alt]="imageToDisplay.alt || 'No Image'"
    [src]="imageToDisplay.url"
    />
  }
